export const FILTER_OPERATION_EQUAL = "=";
export const FILTER_OPERATION_ARRAY_CONTAINS_ALL = "arrayContainsAll";